import { dateFormat } from 'shared/helpers/parsers/date';

import dateAdapter from 'utils/date/dateAdapter';

import { HEDGES } from './hedgesConstants';

const itemsTemplate = [
  {
    label: HEDGES.MARKET_HOLIDAYS.MONTH,
    render: ({ date }) => dateAdapter(date).format('MMMM'),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.DAY,
    render: ({ date }) => dateAdapter(date).format('DD'),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.YEAR,
    render: ({ date }) => dateAdapter(date).format('YYYY'),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.HOLIDAY_NAME,
    render: ({ holidayName }) => holidayName,
    className: 'holidayName',
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.DATE_ADDED,
    render: ({ createdAt }) => dateAdapter(createdAt).format(dateFormat),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.ADDED_BY,
    render: ({ createdBy: { firstName, lastName } }) => `${firstName} ${lastName}`,
    className: 'createdBy',
  },
];

const itemsTemplateMobile = [
  {
    label: HEDGES.MARKET_HOLIDAYS.DATE,
    render: ({ date }) => dateAdapter(date).format(dateFormat),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.HOLIDAY_NAME,
    render: ({ holidayName }) => holidayName,
    className: 'holidayName',
  },
];

const itemsDetailsTemplate = [
  {
    label: HEDGES.MARKET_HOLIDAYS.DATE_ADDED,
    render: ({ createdAt }) => dateAdapter(createdAt).format(dateFormat),
  },
  {
    label: HEDGES.MARKET_HOLIDAYS.ADDED_BY,
    render: ({ createdBy: { firstName, lastName } }) => `${firstName} ${lastName}`,
    className: 'createdBy',
  },
];

export { itemsTemplate, itemsTemplateMobile, itemsDetailsTemplate };
